import React from 'react';
import { Plugins } from '@leverege/plugin';
export const ViewerFactory = Plugins.createFactory('DashboardItem', {
  strategy: Plugins.reactStrategy(React),
  creationKey: 'viewer',
  name: 'viewers'
});
export const EditorFactory = Plugins.createFactory('DashboardItem', {
  strategy: Plugins.reactStrategy(React),
  creationKey: 'editor',
  name: 'editors'
});
export const ModelFactory = Plugins.createFactory('DashboardItem', {
  strategy: Plugins.LOOKUP,
  creationKey: 'model',
  name: 'models'
});
export const OptionEditorFactory = Plugins.createFactory('DashboardOptionEditor', {
  strategy: Plugins.reactStrategy(React),
  creationKey: 'editor'
});